import { render, staticRenderFns } from "./ReportBead.vue?vue&type=template&id=52328a81&scoped=true"
import script from "./ReportBead.vue?vue&type=script&lang=js"
export * from "./ReportBead.vue?vue&type=script&lang=js"
import style0 from "./ReportBead.vue?vue&type=style&index=0&id=52328a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52328a81",
  null
  
)

export default component.exports